module.exports = __webpack_public_path__ + "img/corona-mutationen.131779fc.png";